import { createFileRoute } from "@tanstack/react-router";
import { ConceptLanding } from "@/components/site/ConceptLanding";
export const Route = createFileRoute("/massa/")({
  head: () => ({
    meta: [
      { title: "Mässaktiviteter & monteraktivering | Event Sverige" },
      {
        name: "description",
        content:
          "Gör ett mässbesök till ett möte. Spel, värd och stämningsljus skapar en naturlig väg till ert budskap och ert team. Planera montern med oss.",
      },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/massa" }],
  }),
  component: () => <ConceptLanding segment="massa" />,
});
